document.addEventListener('DOMContentLoaded', function () {

  /* Mobiel menu */
  var toggle = document.querySelector('.site-header__menu-toggle');
  var nav = document.getElementById('MobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* Helpers */
  function fmt(cents) {
    return '€' + (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function updateHeaderCount(n) {
    if (window.PV && PV.setCount) { PV.setCount(n); return; }
    var el = document.querySelector('.site-header__cart-count');
    if (el) el.textContent = n;
  }
  function showFeedback(el, msg, ok) {
    if (!el) return;
    el.textContent = msg;
    el.className = 'cart-feedback ' + (ok ? 'is-success' : 'is-error');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.className = 'cart-feedback'; }, 4500);
  }

  /* Aantal kiezen (productpagina) */
  function initQty(wrapId, inputId) {
    var wrap = document.getElementById(wrapId);
    if (!wrap) return;
    var inp = document.getElementById(inputId);
    var minus = wrap.querySelector('.qty-selector__btn--minus');
    var plus = wrap.querySelector('.qty-selector__btn--plus');
    var min = parseInt(inp.min, 10) || 1;
    var max = parseInt(inp.max, 10) || 9999;
    function clamp() {
      var v = parseInt(inp.value, 10) || min;
      v = Math.max(min, Math.min(max, v));
      inp.value = v;
      if (minus) minus.disabled = v <= min;
      if (plus) plus.disabled = v >= max;
    }
    if (minus) minus.addEventListener('click', function () { inp.value = parseInt(inp.value, 10) - 1; clamp(); });
    if (plus) plus.addEventListener('click', function () { inp.value = parseInt(inp.value, 10) + 1; clamp(); });
    inp.addEventListener('change', clamp);
    inp.addEventListener('blur', clamp);
    clamp();
  }
  initQty('ProductQtySelector', 'ProductQty');

  /* Variantkeuze (klikbare knoppen) */
  var variantBtns = document.querySelectorAll('.variant-btn');
  if (variantBtns.length) {
    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.classList.contains('is-sold-out')) return;
        variantBtns.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        var isAvail = this.getAttribute('data-available') === 'true';
        var iqty = parseInt(this.getAttribute('data-qty'), 10) || 9999;
        var policy = this.getAttribute('data-policy');
        var varId = this.getAttribute('data-variant-id');
        var priceFmt = this.getAttribute('data-price-fmt');
        var cmpFmt = this.getAttribute('data-compare-fmt');
        var priceCents = parseInt(this.getAttribute('data-price'), 10) || 0;
        var cmpCents = parseInt(this.getAttribute('data-compare-price'), 10) || 0;

        var hiddenId = document.getElementById('ProductVariantId');
        if (hiddenId) {
          hiddenId.value = varId;
          hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var priceEl = document.getElementById('ProductPrice');
        if (priceEl) {
          var html = priceFmt;
          if (cmpCents > priceCents) html += ' <s>' + cmpFmt + '</s>';
          priceEl.innerHTML = html;
        }

        var atcRow = document.getElementById('AtcRow');
        var soBtn = document.getElementById('SoldOutBtn');
        var soBadge = document.getElementById('SoldOutBadge');
        var payBtns = document.getElementById('PayBtns');
        if (isAvail) {
          if (atcRow) atcRow.style.display = '';
          if (soBtn) soBtn.style.display = 'none';
          if (soBadge) soBadge.style.display = 'none';
          if (payBtns) payBtns.style.display = '';
          var qi = document.getElementById('ProductQty');
          if (qi) { qi.max = (policy === 'deny') ? iqty : 9999; }
          initQty('ProductQtySelector', 'ProductQty');
        } else {
          if (atcRow) atcRow.style.display = 'none';
          if (soBtn) soBtn.style.display = '';
          if (soBadge) soBadge.style.display = '';
          if (payBtns) payBtns.style.display = 'none';
        }
      });
    });
  }

  /* Product toevoegen via AJAX */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    var addBtn = document.getElementById('AddToCartBtn');
    var feedback = document.getElementById('CartFeedback');

    productForm.addEventListener('submit', function (e) {
      /* Direct afrekenen laat Shopify zijn gang gaan */
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();
      if (!addBtn || addBtn.disabled) return;

      var variantId = document.getElementById('ProductVariantId').value;
      var qty = parseInt(document.getElementById('ProductQty').value, 10) || 1;

      addBtn.disabled = true;
      addBtn.textContent = 'Toevoegen…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Fout'); });
        return r.json();
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateHeaderCount(cart.item_count);
        addBtn.textContent = '✓ Toegevoegd!';
        if (window.PV && PV.openCart) {
          PV.openCart(cart);
        } else {
          showFeedback(feedback, '✓ ' + qty + '× toegevoegd aan je winkelwagen!', true);
        }
        setTimeout(function () {
          addBtn.textContent = 'In winkelwagen';
          addBtn.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        showFeedback(feedback, err.message || 'Kon product niet toevoegen.', false);
        addBtn.textContent = 'In winkelwagen';
        addBtn.disabled = false;
      });
    });
  }

  /* Winkelwagenpagina: aantal wijzigen en verwijderen */
  var cartSection = document.getElementById('CartSection');
  if (cartSection) {
    function cartChange(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); });
    }
    function updateTotals(cart) {
      updateHeaderCount(cart.item_count);
      var sub = document.getElementById('CartSubtotal');
      var tot = document.getElementById('CartTotal');
      if (sub) sub.textContent = fmt(cart.total_price);
      if (tot) tot.textContent = fmt(cart.total_price);
      if (window.PV && PV.updateShipBars) PV.updateShipBars(cart.total_price);
    }
    function reloadIfEmpty(cart) {
      if (cart.item_count === 0) { setTimeout(function () { location.reload(); }, 300); }
    }
    cartSection.querySelectorAll('.cart-item').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      var inp = row.querySelector('.cart-item__qty-input');
      var minus = row.querySelector('.cart-item__qty-btn--minus');
      var plus = row.querySelector('.cart-item__qty-btn--plus');
      var removeBtn = row.querySelector('.cart-item__remove');
      var linePrice = row.querySelector('[data-line-price]');
      function doUpdate(qty) {
        row.style.opacity = '0.5';
        row.style.pointerEvents = 'none';
        cartChange(line, qty).then(function (cart) {
          row.style.opacity = '1';
          row.style.pointerEvents = '';
          if (!cart || !cart.items) { location.reload(); return; }
          updateTotals(cart);
          if (qty === 0) {
            row.style.transition = 'opacity .2s';
            row.style.opacity = '0';
            setTimeout(function () { row.remove(); reloadIfEmpty(cart); }, 220);
          } else {
            var idx = line - 1;
            if (linePrice && cart.items && cart.items[idx]) {
              linePrice.textContent = fmt(cart.items[idx].final_line_price);
            }
          }
        }).catch(function () {
          row.style.opacity = '1';
          row.style.pointerEvents = '';
        });
      }
      if (minus) minus.addEventListener('click', function () { var v = Math.max(0, parseInt(inp.value, 10) - 1); inp.value = v; doUpdate(v); });
      if (plus) plus.addEventListener('click', function () { var v = parseInt(inp.value, 10) + 1; inp.value = v; doUpdate(v); });
      if (inp) inp.addEventListener('change', function () { doUpdate(Math.max(0, parseInt(inp.value, 10) || 0)); });
      if (removeBtn) removeBtn.addEventListener('click', function () { doUpdate(0); });
    });
  }

  /* Club finder */
  var clubForm = document.querySelector('[data-club-finder-form]');
  if (clubForm) {
    clubForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = document.getElementById('ClubFinderLocation');
      var map = document.querySelector('[data-club-finder-map]');
      var external = document.querySelector('[data-club-finder-external]');
      var loc = input ? input.value.trim() : '';
      if (!loc) return;
      var query = encodeURIComponent('padelclub near ' + loc);
      if (map) map.src = 'https://www.google.com/maps?q=' + query + '&t=&z=12&ie=UTF8&iwloc=&output=embed';
      if (external) external.href = 'https://www.google.com/maps/search/?api=1&query=' + query;
    });
  }

});
